import { SPM_POSITION_OFFSET, type SpmPageCodes } from './types';
import type { SpmTerminalKind } from './terminal';

export function withGoodsListPage(
  codes: SpmPageCodes,
  groupId: string | number,
  platform: SpmTerminalKind,
): SpmPageCodes {
  const page = `product_list_${groupId}_${platform}`;
  return Object.fromEntries(
    Object.entries(codes).map(([key, module]) => [
      key,
      Object.assign(
        Object.fromEntries(
          Object.entries(module).map(([position, code]) => [
            position,
            typeof code === 'string'
              ? code.replace(/\.product_list_(?:pc|wap|app)\./, `.${page}.`)
              : code,
          ]),
        ),
        module[SPM_POSITION_OFFSET] === undefined
          ? {}
          : { [SPM_POSITION_OFFSET]: module[SPM_POSITION_OFFSET] },
      ),
    ]),
  ) as SpmPageCodes;
}
